import { useIsFeatureEnabled } from '@shared/core/featureFlags';

// Standalone so SSR-critical callers (e.g. RegistrationThemeBackground in the guest-head chunk) can read the
// "Make Registration look like my site" matching flag without pulling in RegistrationFormTypographyProvider's
// heavy module graph (the @apps/guest barrel via useColorPaletteProvider, joykit styled components).
export const useRegistrationFormMatching = () => {
  const [isConsentEnabled, isConsentLoading] = useIsFeatureEnabled({ consentKey: 'registrationFormMatchingWebsite' });
  return { isEnabled: !isConsentLoading && isConsentEnabled, isLoading: isConsentLoading };
};
